var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content has-text-grey has-text-centered"},[_c('p',[_c('b-icon',{attrs:{"icon":"exclamation-triangle","size":"is-large"}})],1),_c('p',{directives:[{name:"t",rawName:"v-t",value:('nothing_found'),expression:"'nothing_found'"}]})])
}
var staticRenderFns = []

export { render, staticRenderFns }